import type SelectionDropdown from "../../../table-actions-panel/models/selection-dropdown/SelectionDropdown";

import { WEBSITES_SAVE_TO_LIST_SELECTION_TOP_N_VALUES } from "./constants";
import createSaveToListSelectionDropdown from "./factory";

const saveToListSelectionDropdown: SelectionDropdown = createSaveToListSelectionDropdown({
    topNValues: WEBSITES_SAVE_TO_LIST_SELECTION_TOP_N_VALUES,
});

export default saveToListSelectionDropdown;
